import { useState } from "react"
import addbanner from '../../../assets/images/core/CreateBanner.png'
import logo from '../../../assets/images/logos/Input.png'


export const JobPostList = () => {

    // const [list, setList]= useState(false)
    const [listData, setListData] = useState([])
    const [form, setForm] = useState ({ type: "create",
    submit: {modal: false, type: '', confirmed: false},
    inputs:{
        name: {value: '', stat: false, msg: '', toggled: false},
        position: {value: '', stat: false, msg: '', toggled: false},
        qualification: [{value: '', stat: false, msg: '', toggled: false}],
        description: [{value: '', stat: false, msg: '', toggled: false}],
        benefits: [{value: '', stat: false, msg: '', toggled: false}],
        banner: {value: null, object: addbanner, name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
        logo: {value: '', object: logo, name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
        location: {value: '', stat: false, msg: '', toggled: false},
        overview: {value: '', stat: false, msg: '', toggled: false},
        start_date: {value: 1, stat: false, msg: '', toggled: false},
        end_date: {value: 1, stat: false, msg: '', toggled: false},
        status: {value: '', stat: false, msg: '', toggled: false},
        user_id: {value: 1, stat: false, msg: '', toggled: false},
        company_id: {value: 1, stat: false, msg: '', toggled: false},
        statupdate: {value: 1, stat: false, msg: '', toggled: false},
        deployment: {value: '', stat: false, msg: '', toggled: false},
        employment: {value: '', stat: false, msg: '', toggled: false},
        // project: {value: '', stat: false, msg: '', toggled: false},
    }})
 
  return {

    // list: {data: list, set: setList}, 
    listData: {data: listData, set: setListData},
    form: {data: form, set: setForm},

  }
}